import styled from 'styled-components';

export const MyloBabyTrustContainer = styled.div`
  .ImageContainer {
    position: relative;
    width: 100%;
    padding-top: 75%;
  }

  .skewClass {
    transform: skew(-14deg);
  }
`;

export const JoyBundleSection = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
  width: 80%;
  margin: 0 auto;
  @media (max-width: 720px) {
    width: 100%;
  }

  .myloImageContainer {
    position: relative;
    padding-top: 29.3%;
    width: 89%;
    max-width: 89%;

    span {
      margin-right: 8px !important;
    }
  }

  .title {
    font-size: clamp(18px, 2vw, 20px);
    font-weight: 600;
    text-align: left;
    color: hsl(0deg, 0%, 0%, 80%);
  }

  .subTitle {
    font-size: clamp(12px, 2vw, 14px);
    font-weight: 500;
    text-align: left;
    color: hsl(0deg, 0%, 0%, 87%);
    padding-top: 12px;
    line-height: 1.75;
  }

  .textSection {
    padding-left: 30px;
    @media (max-width: 720px) {
      padding-left: 16px;
    }

    border-left: solid 1px #dadada;
  }
`;

export const GetToKnow = styled.div`
  .shape {
    font-size: 12px;
    font-weight: normal;
    text-align: left;
    color: hsl(0deg, 0%, 0%, 87%);
    background-color: #f9f9f9;
    width: max-content;
    padding: 6px 10px;
    margin: 20px 0;
    position: relative;
  }

  .shape:after {
    content: '';
    position: absolute;
    right: -6px;
    top: 0;
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg);
    transform: skew(-20deg);
    width: 10px;
    background-color: #f9f9f9;
    height: 100%;
  }
`;

export const TrustPointers = styled.div`
  .pointers {
    display: flex;
    align-items: center;

    :not(:last-child) {
      padding-bottom: 18px;
    }
  }

  p {
    font-size: clamp(12px, 2vw, 14px);
    line-height: 1.27;
    text-align: left;
    color: hsl(0deg, 0%, 0%, 87%);
    padding-left: 12px;
  }

  span {
    width: 30px !important;
    height: 30px !important;
    @media (max-width: 720px) {
      width: 24px !important;
      heignt: 24px !important;
    }
  }
`;
export const CounterSection = styled.div`
  padding: 0 16px;
`;
